import React from "react";
export default function Minus({ style }) {
    return (React.createElement("svg", { style: style, viewBox: "0 0 500 500" },
        React.createElement("path", { transform: "matrix(0, 1, -1, 0, 500, 0)", d: "M 250 0 H 250 A 50 50 0 0 1 300 50 V 450 A 50 50 0 0 1 250 500 H 250 A 50 50 0 0 1 200 450 V 50 A 50 50 0 0 1 250 0 Z" })));
}
